module.exports = __webpack_public_path__ + "static/media/topic-action@3x.fce831a8.png";